export default "__VITE_ASSET__CUpinr89__"